import { SET_SERVER_PROFILES } from './constants'

// Initial state of the store
const initialState = {}
// Sample state:
// {
//     tq: ['Default'],
// }

export default function servers(state = initialState, action) {
    switch (action.type) {
        // Update the list of profiles
        case SET_SERVER_PROFILES: {
            const { serverId, profiles: serverProfiles } = action.payload
            let profiles = [...serverProfiles]
            if (profiles.length < 1) {
                profiles = ['Default']
            }
            return {
                ...state,
                [serverId]: profiles,
            }
        }

        // Do nothing
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/serverProfiles/reducer.js